module.exports = __webpack_public_path__ + "img/long-info-bullet-1.d62db167.svg";